export default{
    caminos: [],
    caminoSelec: null,
    tarifaSelec: null,
}